import { CheckIcon, LockClosedIcon } from "@heroicons/react/24/outline";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

function Pricing() {
    return (
        <div className="flex h-full px-4 pt-6 pb-24 md:px-10">
            <div className="container mx-auto md:pt-15">
                <div className="mx-auto prose max-w-4xl prose-darkgreen">
                    <p className="text-center text-sm font-medium tracking-[0.32em] text-neutral-400 uppercase">
                        For clinicians
                    </p>

                    <h1 className="mb-4 text-center text-6xl font-semibold tracking-wider">
                        Simple, fair pricing.
                    </h1>

                    <p className="lead mx-auto mb-8 max-w-2xl text-center text-neutral-500">
                        One subscription, one fee for each brand-new patient we
                        bring you, and nothing ever again for the patients who
                        come back.
                    </p>
                </div>
                <div className="grid grid-cols-12 gap-x-8 gap-y-6">
                    <div className="col-span-full md:col-span-6">
                        <Card size="lg" className="h-full">
                            <p className="mb-5 text-xs font-medium tracking-[0.32em] text-neutral-400 uppercase">
                                Subscription
                            </p>
                            <p className="mb-3 text-4xl font-semibold">
                                £18.99
                            </p>
                            <p className="mb-5 text-sm text-neutral-500">
                                per month
                            </p>
                            <ul className="grid list-none gap-3 ps-0">
                                <li>
                                    <div className="flex items-start gap-2">
                                        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-emerald-950 font-bold">
                                            <CheckIcon className="size-4 shrink-0 stroke-2" />
                                        </span>
                                        Your verified profile, diary and booking
                                        tools
                                    </div>
                                </li>
                                <li>
                                    <div className="flex items-start gap-2">
                                        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-emerald-950 font-bold">
                                            <CheckIcon className="size-4 shrink-0 stroke-2" />
                                        </span>
                                        Credential tracking and smart reminders
                                    </div>
                                </li>
                                <li>
                                    <div className="flex items-start gap-2">
                                        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-emerald-950 font-bold">
                                            <CheckIcon className="size-4 shrink-0 stroke-2" />
                                        </span>
                                        Cancel any time: no long contracts
                                    </div>
                                </li>
                            </ul>
                        </Card>
                    </div>
                    <div className="col-span-full md:col-span-6">
                        <Card size="lg" className="h-full bg-sky-50/25">
                            <p className="mb-5 text-xs font-medium tracking-[0.32em] text-neutral-400 uppercase">
                                New patient fee
                            </p>
                            <p className="mb-3 text-4xl font-semibold">
                                Per new patient
                            </p>
                            <p className="mb-5 text-sm text-neutral-500">
                                a one-time fee, only when we introduce a
                                brand-new patient
                            </p>
                            <ul className="grid list-none gap-3 ps-0">
                                <li>
                                    <div className="flex items-start gap-2">
                                        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-emerald-950 font-bold">
                                            <CheckIcon className="size-4 shrink-0 stroke-2" />
                                        </span>
                                        Pay only for genuinely new patients
                                        Welnido brings you
                                    </div>
                                </li>
                                <li>
                                    <div className="flex items-start gap-2">
                                        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-emerald-950 font-bold">
                                            <CheckIcon className="size-4 shrink-0 stroke-2" />
                                        </span>
                                        <span>
                                            <strong>No repeat costs</strong>:
                                            once a patient is yours, every
                                            rebooking is free, forever
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div className="flex items-start gap-2">
                                        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-emerald-950 font-bold">
                                            <CheckIcon className="size-4 shrink-0 stroke-2" />
                                        </span>
                                        Clear, predictable costs: no surprises
                                    </div>
                                </li>
                            </ul>
                        </Card>
                    </div>
                    <Card className="flex gap-x-2 md:items-center">
                        <LockClosedIcon className="size-5 shrink-0 stroke-2 md:size-6" />
                        <p>
                            <strong>Payments powered by Stripe.</strong>
                            <span className="text-neutral-500">
                                {" "}
                                All subscriptions and fees are handled securely
                                by Stripe, the trusted, industry-leading payment
                                platform respected by millions of businesses
                                worldwide. Welnido never stores your card
                                details.
                            </span>
                        </p>
                    </Card>
                    <Card
                        size="lg"
                        className="flex flex-col gap-x-2 bg-darkgreen-500 md:flex-row md:items-center"
                    >
                        <div>
                            <p className="mb-3 font-[Montserrat] text-2xl font-semibold text-white">
                                Your first 3 months are free.
                            </p>
                            <p className="mb-3 text-beige md:mb-3">
                                Every new practice starts with{" "}
                                <span className="text-emerald-950">
                                    3 months free
                                </span>
                                , full platform, no card required to explore, no
                                catches.
                            </p>
                        </div>
                        <Button variant="success" className="ms-auto">
                            Start free today
                        </Button>
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default Pricing;
